import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import FormSection from "../../shared/component/form/FormSection";
import OrderService from "../../shared/service/OrderService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Dialog from "../../shared/component/dialog/Dialog";
import './OrdersKitchen.css';

export default class OrdersKitchen extends React.Component {
    static getColumnCount() {
        if (typeof window === 'undefined') {
            return 4;
        }
        if (window.innerWidth <= 992) {
            return 2;
        }
        if (window.innerWidth <= 1400) {
            return 3;
        }
        return 4;
    }

    constructor(props) {
        super(props);
        this.state = {
            orderList: [],
            itemsOverflow: {},
            displayDialog: false,
            selectedOrder: null,
            columnCount: OrdersKitchen.getColumnCount(),
        };
        this.orderService = new OrderService();
        this.itemViewportRefs = {};
    }

    componentDidMount() {
        this.getNewOrders();

        // 5 saniyede bir sorguyu tekrar çek
        this.orderInterval = setInterval(() => {
            this.getNewOrders();
        }, 10000);

        this.handleWindowResize = () => {
            const columnCount = OrdersKitchen.getColumnCount();
            if (columnCount !== this.state.columnCount) {
                this.setState({columnCount}, this.scheduleItemsOverflowMeasure);
            } else {
                this.scheduleItemsOverflowMeasure();
            }
        };
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.orderList !== this.state.orderList
            || prevState.columnCount !== this.state.columnCount
        ) {
            this.scheduleItemsOverflowMeasure();
        }
    }

    componentWillUnmount() {
        clearInterval(this.orderInterval);
        window.removeEventListener('resize', this.handleWindowResize);
        if (this.overflowMeasureTimer) {
            clearTimeout(this.overflowMeasureTimer);
        }
    }


    getNewOrders() {
        this.orderService.getOrdersForKitchen().then(response => this.setState({
            orderList: this.normalizeOrderList(response)
        }, this.scheduleItemsOverflowMeasure));

    }

    setItemViewportRef = (orderNo) => (element) => {
        if (element) {
            this.itemViewportRefs[orderNo] = element;
        } else {
            delete this.itemViewportRefs[orderNo];
        }
    }

    scheduleItemsOverflowMeasure = () => {
        if (this.overflowMeasureTimer) {
            clearTimeout(this.overflowMeasureTimer);
        }
        this.overflowMeasureTimer = setTimeout(() => {
            this.overflowMeasureTimer = null;
            this.measureItemsOverflow();
        }, 0);
    }

    measureItemsOverflow = () => {
        const {orderList, itemsOverflow} = this.state;
        const nextOverflow = {};

        orderList.forEach((order) => {
            const viewport = this.itemViewportRefs[order.orderNo];
            if (!viewport) {
                return;
            }
            nextOverflow[order.orderNo] = viewport.scrollHeight > viewport.clientHeight + 2;
        });

        if (!this.hasItemsOverflowChanged(itemsOverflow, nextOverflow)) {
            return;
        }

        this.setState({itemsOverflow: nextOverflow});
    }

    hasItemsOverflowChanged = (previous, next) => {
        const keys = new Set([
            ...Object.keys(previous || {}),
            ...Object.keys(next || {}),
        ]);

        for (const key of keys) {
            if (Boolean(previous[key]) !== Boolean(next[key])) {
                return true;
            }
        }

        return false;
    }

    getKitchenItemLineCount = (items) => {
        return Array.isArray(items) ? items.length : 0;
    }

    /** One grid row per slice; divider drawn between rows */
    chunkOrdersIntoRows = (orders, columnCount) => {
        const rows = [];

        for (let index = 0; index < orders.length; index += columnCount) {
            rows.push(orders.slice(index, index + columnCount));
        }

        return rows;
    }

    renderOrderCard = (order, itemsOverflow) => {
        const isWEB = order.orderNo.startsWith("WEB");
        const displayOrderNo = isWEB ? order.orderNo : `TILL-${order.orderNo}`;

        let backgroundColor = '#E5E7EB';
        let badgeText = '';
        let badgeStyle = {};

        if (order.orderStatus === "ORDER_ACCEPTED") {
            backgroundColor = '#F59E0B';
            badgeText = 'READY';
            badgeStyle = {
                backgroundColor: '#D97706',
                animationClass: '',
            };
        } else if (order.orderStatus === "ORDER_PREPARING") {
            backgroundColor = '#3B82F6';
            badgeText = 'PREPARING';
            badgeStyle = {
                backgroundColor: '#2563EB',
                animationClass: '',
            };
        } else if (order.orderStatus === "ORDER_READY") {
            backgroundColor = '#10B981';
            badgeText = 'NEW';
            badgeStyle = {
                backgroundColor: '#16A34A',
                animationClass: 'blinking-badge',
            };
        }

        const hasOverflow = Boolean(itemsOverflow[order.orderNo]);
        const lineCount = this.getKitchenItemLineCount(order.basketDetailKitchenList);
        const hasContentChange = Boolean(order.kitchenContentChanged);
        const badgeWrapPadding = badgeText ? '92px' : 0;

        return (
            <div
                key={order.orderNo}
                className="kitchen-display-card"
                style={{
                    backgroundColor,
                    color: 'white',
                }}
            >
                {badgeText && (
                    <div className="kitchen-display-card__badge-wrap">
                        <div
                            className={badgeStyle.animationClass}
                            style={{
                                backgroundColor: badgeStyle.backgroundColor,
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '4px 10px',
                                borderRadius: '8px',
                                fontSize: '18px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {badgeText}
                        </div>
                        {isWEB && (
                            <span
                                className="pi pi-cloud kitchen-display-card__cloud"
                            />
                        )}
                    </div>
                )}

                <div className="kitchen-display-card__content">
                    <div style={{paddingRight: badgeWrapPadding}}>
                        <div
                            className="kitchen-display-card-meta"
                            style={{
                                fontSize: '14px',
                                marginBottom: '4px',
                                color: 'white',
                            }}
                        >
                            {displayOrderNo} ({order.orderType.replace(/_/g, " ")})
                        </div>

                        <div
                            className="kitchen-display-card-meta"
                            style={{
                                fontSize: '14px',
                                marginBottom: '4px',
                                color: 'white',
                            }}
                        >
                            Order Time: {order.orderTime}
                            {order.eatInTableDisplayName ? ` (Table: ${order.eatInTableDisplayName})` : ''}
                        </div>

                        {hasContentChange ? (
                            <div
                                className="kitchen-display-card-meta kitchen-display-card__content-change-line blinking-badge"
                                role="status"
                                aria-live="polite"
                            >
                                CONTENT CHANGE
                            </div>
                        ) : isWEB ? (
                            <div
                                className="kitchen-display-card-meta"
                                style={{
                                    fontSize: '14px',
                                    marginBottom: '4px',
                                    color: 'white',
                                }}
                            >
                                Ready By: {order.deliveryDateString}
                            </div>
                        ) : (
                            <div
                                className="kitchen-display-card-meta"
                                style={{
                                    visibility: 'hidden',
                                    fontSize: '14px',
                                    marginBottom: '4px',
                                }}
                            >
                                Ready By:
                            </div>
                        )}
                    </div>

                    <div className="kitchen-order-items">
                        <div
                            className={`kitchen-order-items__viewport${hasOverflow ? ' kitchen-order-items__viewport--clipped' : ''}`}
                            ref={this.setItemViewportRef(order.orderNo)}
                        >
                            {this.renderKitchenItems(order.basketDetailKitchenList)}
                        </div>
                        {hasOverflow && (
                            <button
                                type="button"
                                className="kitchen-order-items__more"
                                onClick={() => this.toggleOrderDetails(order)}
                            >
                                Show more ({lineCount})
                            </button>
                        )}
                    </div>
                </div>

                <div className="kitchen-display-card__actions">
                    {order.orderStatus === "ORDER_ACCEPTED" && order.basketStatus !== "CANCELLED" && (
                        <button
                            type="button"
                            className="kitchen-display-card__btn"
                            onClick={() => this.preparing(order)}
                        >
                            Start Preparing
                        </button>
                    )}

                    {order.orderStatus === "ORDER_PREPARING" && (
                        <button
                            type="button"
                            className="kitchen-display-card__btn"
                            onClick={() => this.ready(order)}
                        >
                            Order Ready
                        </button>
                    )}

                    {order.orderStatus === "ORDER_READY" && (
                        <button
                            type="button"
                            className="kitchen-display-card__btn"
                            onClick={() => this.deliver(order)}
                        >
                            Deliver Order
                        </button>
                    )}
                </div>
            </div>
        );
    }

    normalizeOrderList = (response) => {
        return Array.isArray(response) ? response : [];
    }

    renderKitchenItems = (items) => {
        if (!Array.isArray(items) || items.length === 0) {
            return null;
        }

        return (
            <ul className="kitchen-display-items">
                {items.map((item, index) => {
                    if (item.header === true) {
                        return (
                            <li
                                key={`header-${item.description}-${index}`}
                                className="kitchen-display-items__row kitchen-display-items__row--header"
                            >
                                <span className="kitchen-display-items__name kitchen-display-items__name--header">
                                    {item.description}
                                </span>
                            </li>
                        );
                    }

                    const isModifier = !GeneralUtils.isNullOrEmpty(item.parentBssId);

                    return (
                        <li
                            key={`${item.id || item.bssId || item.description}-${index}`}
                            className={`kitchen-display-items__row${isModifier ? ' kitchen-display-items__row--modifier' : ''}`}
                        >
                            <span className="kitchen-display-items__qty">{item.quantity}</span>
                            <span className={`kitchen-display-items__name${isModifier ? ' kitchen-display-items__name--modifier' : ' kitchen-display-items__name--item'}`}>
                                {item.description}
                                {!GeneralUtils.isNullOrEmpty(item.extraNotes) && (
                                    <span className="kitchen-display-items__notes">Notes: {item.extraNotes}</span>
                                )}
                            </span>
                        </li>
                    );
                })}
            </ul>
        );
    }

    render() {
        return (
            <div>
                <AvForm>
                    {this.newOrderList()}
                </AvForm>
            </div>
        );
    }

    newOrderList() {
        const {orderList, itemsOverflow, selectedOrder, displayDialog, columnCount} = this.state;
        const orderRows = this.chunkOrdersIntoRows(orderList, columnCount);

        return (
            <>
                <FormSection className="kitchen-display-section">
                    <div className="kitchen-display-scroll">
                        {orderRows.map((rowOrders, rowIndex) => (
                            <React.Fragment key={`row-${rowIndex}`}>
                                <div
                                    className="kitchen-display-row"
                                    style={{'--kitchen-display-columns': columnCount}}
                                >
                                    {Array.from({length: columnCount}).map((_, cellIndex) => {
                                        const order = rowOrders[cellIndex];
                                        if (!order) {
                                            return (
                                                <div
                                                    key={`empty-${rowIndex}-${cellIndex}`}
                                                    className="kitchen-display-card-placeholder"
                                                    aria-hidden="true"
                                                />
                                            );
                                        }

                                        return this.renderOrderCard(order, itemsOverflow);
                                    })}
                                </div>
                                {rowIndex < orderRows.length - 1 && (
                                    <div className="kitchen-display-row-rule" aria-hidden="true" />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </FormSection>

                {selectedOrder && (
                    <Dialog
                        visible={displayDialog}
                        onHide={this.closeDisplayDialog}
                        style={GeneralUtils.getDialogStyleKitchenDisplayForDialog()}
                    >
                        <div className="kitchen-order-dialog-header">
                            <div>{selectedOrder.orderNo}</div>
                            <div>Order Time: {selectedOrder.orderTime}</div>
                            {selectedOrder.deliveryDateString && (
                                <div>Ready By: {selectedOrder.deliveryDateString}</div>
                            )}
                        </div>
                        <div className="kitchen-order-items kitchen-order-items--dialog">
                            {this.renderKitchenItems(selectedOrder.basketDetailKitchenList)}
                        </div>
                        <button
                            type="button"
                            className="kitchen-order-dialog-close"
                            onClick={this.closeDisplayDialog}
                        >
                            Close
                        </button>
                    </Dialog>
                )}
            </>
        );
    }

    preparing = (order) => {
        if (!GeneralUtils.isNullOrEmpty(order.id)) {
            this.orderService.preparingOrder(order.id).then(() => {
                this.getNewOrders();
            });
        }
    }

    ready = (order) => {
        if (!GeneralUtils.isNullOrEmpty(order.id)) {
            this.orderService.readyOrder(order.id).then(() => {
                this.getNewOrders();
            });
        }
    }

    deliver = (order) => {
        if (!GeneralUtils.isNullOrEmpty(order.id)) {
            this.orderService.deliverOrder(order.id).then(() => {
                this.getNewOrders();
            });
        }
    }

    toggleOrderDetails = (order) => {
        this.setState({
            displayDialog: true,
            selectedOrder: {...order},
        });
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false, selectedOrder: null});
    }

}
